import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Button,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  CircularProgress,
  TablePagination,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import MembershipEventsWrapper from './membership-events-wrapper';
import { useGetMembershipEvents, useDeleteMembershipEvent } from 'api/membership-events';
import MembershipEventTableRow from './membership-events-table-row';

const MembershipEvents = () => {
  const [params, setParams] = useState({ page_index: 0, page_size: 25 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedMembershipEvent, setSelectedMembershipEvent] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const { isLoading, data: membershipEvents, refetch } = useGetMembershipEvents(params, { refetchOnMount: true });
  const { mutate: deleteMembershipEvent } = useDeleteMembershipEvent({ onSuccess: refetch });

  function handleChangePage(_, page) {
    setParams({ ...params, page_index: page });
  }

  function handleChangeRowsPerPage({ target: { value } }) {
    setParams({ ...params, page_index: 0, page_size: value });
  }

  function confirmDelete(id) {
    setSelectedMembershipEvent(membershipEvents?.results.find(mp => mp.id === id));
    setIsDialogOpen(true);
  }

  async function doDelete() {
    setIsDeleting(true);
    await deleteMembershipEvent(selectedMembershipEvent.id);
    setIsDialogOpen(false);
    setIsDeleting(false);
  }

  return (
    <MembershipEventsWrapper>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          {isLoading && <CircularProgress />}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Schedule</TableCell>
                <TableCell>Links</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  rowsPerPage={params.page_size}
                  count={membershipEvents?.total || 0}
                  page={params.page_index}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
              {membershipEvents?.results?.map(membershipEvent => (
                <MembershipEventTableRow
                  key={membershipEvent.id}
                  membershipEvent={membershipEvent}
                  confirmDeleleteMembershipEvent={confirmDelete}
                  isDeletsing={isDeleting}
                />
              ))}
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  rowsPerPage={params.page_size}
                  count={membershipEvents?.total || 0}
                  page={params.page_index}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Dialog open={isDialogOpen}>
        <DialogContent>
          <div>{`Are you sure you want to delete event with title ${selectedMembershipEvent?.title}`}</div>
          <Button variant="contained" size="small" onClick={doDelete}>
            Continue
          </Button>
          <Button variant="contained" size="small" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
        </DialogContent>
      </Dialog>
    </MembershipEventsWrapper>
  );
};

const styles = theme => ({
  actionButton: {
    marginRight: theme.spacing(1),
  },
  rightActionContianer: {
    textAlign: 'right',
  },
});

export default withStyles(styles)(MembershipEvents);
